import { useQuery } from 'react-query';
import { NewsApi, NewsFeedItem } from '../../NewsApi';

export const newsFeedQueryKey = 'news-feed';

const fiveMinutes = 5 * 60 * 1000;

export function useNewsFeedQuery(userId: number, onError?: (error: unknown) => void) {
    return useQuery<NewsFeedItem[]>([newsFeedQueryKey, userId], () => NewsApi.getNewsFeed(), {
        staleTime: fiveMinutes,
        refetchInterval: fiveMinutes,
        refetchOnWindowFocus: false,
        onError
    });
}
